import api from "../api";

export interface Airport {
  average_wait_time: string;
  averageWaitTime: any;
  city: string;
  closing_time: string;
  code: any;
  country: string;
  created_at?: string;
  featured: any;
  hidden: boolean;
  iata_code: string;
  id: number | string;
  image_alt_text: string;
  image_url: string;
  isActive: unknown;
  latitude: number;
  longitude: number;
  name: string;
  opening_time: string;
  operatingHours: any;
  order: number;
  services: any;
  services_available: string[];
  timezone: string;
  updated_at?: string;
  updated_by?: string;
}

function fromBackendPayload(data: any): Airport {
  return {
    average_wait_time: data.average_wait_time,
    averageWaitTime: data.average_wait_time ?? data.averageWaitTime,
    city: data.city,
    closing_time: data.closing_time,
    code: data.code,
    country: data.country,
    created_at: data.created_at,
    featured: data.featured === true || data.featured === 1 ? true : false,
    hidden: !!data.hidden,
    iata_code: data.iata_code,
    id: data.id,
    image_alt_text: data.image_alt_text,
    image_url: data.image_url,
    isActive: data.is_active ?? data.isActive ?? !data.hidden,
    latitude: data.latitude,
    longitude: data.longitude,
    name: data.name,
    opening_time: data.opening_time,
    operatingHours: data.operating_hours ?? data.operatingHours,
    order: data.order ?? 0,
    services: data.services || data.services_available || [],
    services_available: data.services_available || [],
    timezone: data.timezone,
    updated_at: data.updated_at,
    updated_by: data.updated_by,
  };
}

function toBackendPayload(airport: Airport) {
  return {
    average_wait_time: airport.average_wait_time,
    city: airport.city,
    closing_time: airport.closing_time,
    country: airport.country,
    featured: airport.featured,
    hidden: airport.hidden,
    iata_code: airport.iata_code,
    image_alt_text: airport.image_alt_text,
    image_url: airport.image_url,
    latitude: airport.latitude,
    longitude: airport.longitude,
    name: airport.name,
    opening_time: airport.opening_time,
    order: airport.order,
    services_available: airport.services_available,
    timezone: airport.timezone,
  };
}

export const AirportsService = {
  async create(airport: Airport): Promise<Airport> {
    const res = await api.post("/airports", toBackendPayload(airport));
    return fromBackendPayload(res.data.airport);
  },
  async delete(id: number | string): Promise<void> {
    await api.delete(`/airports/${id}`);
  },
  async getAll(): Promise<Airport[]> {
    const res = await api.get("/airports");
    return (res.data.airports || []).map(fromBackendPayload);
  },
  async getById(id: number | string): Promise<Airport> {
    const res = await api.get(`/airports/${id}`);
    return fromBackendPayload(res.data.airport);
  },
  async hide(id: number | string): Promise<void> {
    await api.patch(`/airports/${id}/hide`);
  },
  async unhide(id: number | string): Promise<void> {
    await api.patch(`/airports/${id}/unhide`);
  },
  async update(id: number | string, airport: Airport): Promise<Airport> {
    const res = await api.put(`/airports/${id}`, toBackendPayload(airport));
    return fromBackendPayload(res.data.airport);
  },
};
